import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button, Table, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, } from '@fortawesome/free-solid-svg-icons';

import Cargoplane from "../../assets/images/plane.svg";
import Trash from "../../assets/images/trash.png";
import { getTodayDate } from './CommonFunctions';

const DetailsModal = ({ loadData, closeModal, onSave, pos }) => {

    const isMounted = useRef(false);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [modalData, setModalData] = useState(loadData);
    const [activeTab, setActiveTab] = useState('Received');
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    const newRow = {
        warehouse_check: false,
        warehouse_check_date: '',
        spot_check: false,
        spot_check_date: '',
        agent_check: false,
        agent_check_date: '',
        cctv_check: false,
        cctv_check_date: ''
    };
    useEffect(() => {
        if (isMounted.current) return;
        if (pos === 'E' && loadData.handler_action.length) {
            setModalData(loadData)
        } else {
            setModalData({ ...loadData, handler_action: [newRow] })
        }
        isMounted.current = true;
    }, []);

    const handleModalClose = () => {
        setIsModalOpen(false)
        closeModal()
    }

    const addRow = () => {
        // const updatedFormData = [...modalData, newRow];
        // setModalData(updatedFormData);
        setModalData(prevFormData => ({
            ...prevFormData,
            handler_action: [...prevFormData.handler_action, newRow]
        }));
    };

    const removeRow = (id) => {
        setModalData(prevFormData => {
            return {
                ...prevFormData,
                handler_action: prevFormData.handler_action.filter((stack, index) => index !== id)
            };
        });
    };

    const handleRowChange = (idx, fieldName, value) => {
        setModalData(prevFormData => ({
            ...prevFormData,
            handler_action: prevFormData.handler_action.map((stack, index) => {
                if (index === idx) {
                    let updatedStack = {};
                    if (['warehouse_check', 'spot_check', 'agent_check', 'cctv_check'].includes(fieldName)) {
                        if (value === false) {
                            updatedStack = { ...stack, [fieldName]: value, [`${fieldName}_date`]: '' };
                        } else {
                            updatedStack = { ...stack, [fieldName]: value, [`${fieldName}_date`]: getTodayDate() };
                        }
                    } else {
                        updatedStack = { ...stack, [fieldName]: value };
                    }
                    // const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        }));
    };

    const handleUpdate = () => {
        // onSave({ handler_action: modalData.handler_action, handler_feedback_id: modalData.handler_feedback_id });
        onSave(modalData);
        handleModalClose()
    }

    const HandleChange = (e) => {
        const { name, value } = e.target;
        setModalData({...modalData, [name]: value})
    }

    return (
        <Modal
            show={isModalOpen}
            onHide={handleModalClose}
            className={`addfrom change_type ${['T', 'V', 'E', 'M', 'W'].includes(pos) ? 'traced_modal' : ''}`}
            centered size={`${['T', 'V', 'E', 'M', 'W'].includes(pos) ? 'lg' : ''}`}
        >
            <Modal.Header closeButton>
                {['T', 'V'].includes(pos) && <>{pos === 'T' ? 'Traced' : 'Recovery'} History</>}
                {pos === 'E' && <>Recovery Aspects</>}
                {pos === 'M' && <>Message History</>}
                {pos === 'W' && <>Warehouse Details</>}
            </Modal.Header>{console.log('modalData', modalData)}
            <Modal.Body>
                {pos === 'S' &&
                    <>
                        <h3>Flight Information</h3>
                        <p>Flight details and ground handlers details.</p>
                        <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{loadData?.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p className='m-0'>{loadData?.flight_date}</p>
                                <p className='m-0'><img src={Cargoplane} /></p>
                                <p className='m-0'>{loadData?.flight_prefix}-{loadData?.flight_no}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Destination</p>
                                <span>{loadData?.destination}</span>
                            </div>
                        </div>

                        <div className='mawb-list mawb-dv mb-3'>
                            <h4>{loadData?.handler_type} Details:</h4>
                            <ul>
                                <li>
                                    <span>{loadData?.handler_type === 'Airline' ? 'Airline' : 'Handler'} Name</span>
                                    <span>: {loadData?.handler_type === 'Airline' ? loadData?.airline_name : loadData?.handler_name}</span>
                                </li>
                                <li>
                                    <span>Address</span>
                                    <span>: test test</span>
                                </li>
                                <li>
                                    <span>Phone Number</span>
                                    <span>: 12452 56487</span>
                                </li>
                            </ul>
                        </div>
                    </>
                }
                {pos === 'T' &&
                    <>
                        <div className='rounded' style={{ background: '#fff' }}>
                            <Table responsive borderless>
                                <thead>
                                    <tr>
                                        <th>User</th>
                                        <th>Pieces Traced</th>
                                        <th>Tracing Date</th>
                                        <th>Updated Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadData?.trc?.length ?
                                        <>
                                            {loadData?.trc?.map((data, index) => (
                                                <tr key={index}>
                                                    <td><h6>{data?.updated_by_name}</h6><p>{data?.type}</p></td>
                                                    <td>{data?.pieces_traced}</td>
                                                    <td>{data?.tracing_date}</td>
                                                    <td>{data?.updated_at_date}</td>
                                                </tr>
                                            ))}
                                        </>
                                        :
                                        <td colSpan={5}><div style={{ textAlign: 'center' }} className='mt-3'>No Data Available</div></td>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </>
                }
                {pos === 'V' &&
                    <>
                        <div className='rounded' style={{ background: '#fff' }}>
                            <Table responsive borderless>
                                <thead>
                                    <tr>
                                        <th>User</th>
                                        <th>Warehouse Check</th>
                                        <th>Spot Check</th>
                                        <th>Agent Check</th>
                                        <th>CCTV Check</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadData?.trc?.length ?
                                        <>
                                            {loadData?.trc?.map((data, index) => (
                                                <tr key={index}>
                                                    <td><h6>{data?.updated_by_name}</h6><p>{data?.type}</p></td>
                                                    <td>{data?.warehouse_check_date}</td>
                                                    <td>{data?.spot_check_date}</td>
                                                    <td>{data?.agent_check_date}</td>
                                                    <td>{data?.cctv_check_date}</td>
                                                </tr>
                                            ))}
                                        </>
                                        :
                                        <td colSpan={5}><div style={{ textAlign: 'center' }} className='mt-3'>No Data Available</div></td>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </>
                }
                {pos === 'M' &&
                    <>
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} className="booking_tab">
                            <Tab eventKey="Received" title='Received' className='moveto'>
                                <div className='rounded' style={{ background: '#fff' }}>
                                    <Table responsive borderless>
                                        <thead>
                                            <tr>
                                                <th>Subject</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Date Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadData?.trc?.filter(arg => arg.is_send === 0).length ?
                                                <>
                                                    {loadData?.trc?.filter(arg => arg.is_send === 0).map((data, index) => (
                                                        <tr key={index}>
                                                            <td><h6>{data?.message_subject}</h6><p>{data?.is_send === 0 ? 'Recieved' : 'Sent'}</p></td>
                                                            <td>{data?.from_email}</td>
                                                            <td>{data?.to_email}</td>
                                                            <td>{data?.created_at}</td>
                                                        </tr>
                                                    ))}
                                                </>
                                                :
                                                <td colSpan={5}><div style={{ textAlign: 'center' }} className='mt-3'>NO Email Available</div></td>
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>
                            <Tab eventKey="Sent" title='Sent' className='moveto'>
                                <div className='rounded' style={{ background: '#fff' }}>
                                    <Table responsive borderless>
                                        <thead>
                                            <tr>
                                                <th>Subject</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Date Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadData?.trc?.filter(arg => arg.is_send === 1).length ?
                                                <>
                                                    {loadData?.trc?.filter(arg => arg.is_send === 1).map((data, index) => (
                                                        <tr key={index}>
                                                            <td><h6>{data?.message_subject}</h6><p>{data?.is_send === 0 ? 'Recieved' : 'Sent'}</p></td>
                                                            <td>{data?.from_email}</td>
                                                            <td>{data?.to_email?.split(',').map((email, index) => (<div key={index}>{email.trim()}</div>))}</td>
                                                            <td>{data?.created_at}</td>
                                                        </tr>
                                                    ))}
                                                </>
                                                :
                                                <td colSpan={5}><div style={{ textAlign: 'center' }} className='mt-3'>No Data Available</div></td>
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </Tab>
                        </Tabs>

                    </>
                }
                {pos === 'E' &&
                    <>
                        {modalData?.handler_action.map((stn, index) => (
                            <div className='rounded d-flex position-relative rcvry-mdbx' style={{ background: '#fff' }}>
                                <Row className='rcvrybx-wrap position-relative'>
                                    <Col sm={3} className='rcvrybx'>
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            id={`warehouseCheck${index}`}
                                            className="warehouse_check"
                                            label='Warehouse Check'
                                            checked={stn.warehouse_check}
                                            // disabled={!isEditing}
                                            onChange={(e) => handleRowChange(index, 'warehouse_check', e.target.checked)}
                                        />
                                        <Form.Control
                                            type="date"
                                            placeholder=""
                                            name="warehouse_check_date"
                                            value={stn.warehouse_check_date}
                                            disabled={!stn.warehouse_check}
                                            onChange={(e) => handleRowChange(index, 'warehouse_check_date', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={3} className='rcvrybx'>
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            id={`spotcheck${index}`}
                                            className="spot_check"
                                            label='Spot Check'
                                            checked={stn.spot_check}
                                            // disabled={!isEditing}
                                            onChange={(e) => handleRowChange(index, 'spot_check', e.target.checked)}
                                        />
                                        <Form.Control
                                            type="date"
                                            placeholder=""
                                            name="spot_check_date"
                                            value={stn.spot_check_date}
                                            disabled={!stn.spot_check}
                                            onChange={(e) => handleRowChange(index, 'spot_check_date', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={3} className='rcvrybx'>
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            id={`agentcheck${index}`}
                                            className="agent_check"
                                            label='Agent Check'
                                            checked={stn.agent_check}
                                            // disabled={!isEditing}
                                            onChange={(e) => handleRowChange(index, 'agent_check', e.target.checked)}
                                        />
                                        <Form.Control
                                            type="date"
                                            placeholder=""
                                            name="agent_check_date"
                                            value={stn.agent_check_date}
                                            disabled={!stn.agent_check}
                                            onChange={(e) => handleRowChange(index, 'agent_check_date', e.target.value)}
                                        />
                                    </Col>
                                    <Col sm={3} className='rcvrybx'>
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            id={`cctvcheck${index}`}
                                            className="cctv_check"
                                            label='CCTV Check'
                                            checked={stn.cctv_check}
                                            // disabled={!isEditing}
                                            onChange={(e) => handleRowChange(index, 'cctv_check', e.target.checked)}
                                        />
                                        <Form.Control
                                            type="date"
                                            placeholder=""
                                            name="cctv_check_date"
                                            value={stn.cctv_check_date}
                                            disabled={!stn.cctv_check}
                                            onChange={(e) => handleRowChange(index, 'cctv_check_date', e.target.value)}
                                        />
                                    </Col>
                                    <div className='recvry-trash'><img src={Trash} onClick={() => removeRow(index)} /></div>
                                </Row>

                            </div>
                        ))}
                        <div className='text-end mt-2'><Button variant="primary" className='stk_add' onClick={addRow}> <FontAwesomeIcon icon={faPlus} />Add</Button></div>
                    </>
                }
                {pos === 'W' &&
                    <>
                        <div className='rounded position-relative rcvry-mdbx' style={{ background: '#fff' }}>
                            <h4>Import</h4>
                            <Row className='rcvrybx-wrap position-relative'>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Breakdown</Form.Label>
                                    <Form.Control
                                        type='datetime-local'
                                        placeholder=""
                                        name="breakdown"
                                        value={modalData.breakdown}
                                        onChange={HandleChange}
                                    />
                                </Col>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder=""
                                        name="location"
                                        value={modalData.location}
                                        onChange={HandleChange}
                                    />
                                </Col>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Delivery</Form.Label>
                                    <Form.Control
                                        type='datetime-local'
                                        placeholder=""
                                        name="delivery"
                                        value={modalData.delivery}
                                        onChange={HandleChange}
                                    />
                                </Col>
                            </Row>
                            <h4>Export</h4>
                            <Row className='rcvrybx-wrap position-relative'>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Acceptance Time</Form.Label>
                                    <Form.Control
                                        type='datetime-local'
                                        placeholder=""
                                        name="acceptance_time"
                                        value={modalData.acceptance_time}
                                        onChange={HandleChange}
                                    />
                                </Col>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder=""
                                        name="storage_location"
                                        value={modalData.storage_location}
                                        onChange={HandleChange}
                                    />
                                </Col>
                                <Col sm={4} className='rcvrybx'>
                                    <Form.Label>Build Up Time</Form.Label>
                                    <Form.Control
                                        type='datetime-local'
                                        placeholder=""
                                        name="buildup_time"
                                        value={modalData.buildup_time}
                                        onChange={HandleChange}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className='text-end mt-2'><Button variant="primary" className='stk_add' onClick={handleUpdate}>Save</Button></div>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                {pos === 'E' &&
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={handleModalClose}> Cancel </Button>
                        <Button variant="primary" onClick={handleUpdate}> Update </Button>
                    </div>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default DetailsModal